// @ts-nocheck
import { API_URL } from '$lib/conf'
import { JSONAth, toTitleCase, urlPattern } from '$lib/utils'
import db from '$lib/services/db'
import dictionaries from './dictionaries'
import provider from './provider'
import { tick } from 'svelte'
import { navigate } from 'svelte-navigator'
import { writable, derived } from 'svelte/store'

function CustomStore(ini) {
    let { set, subscribe, update } = writable(ini)
    return {
        set,
        subscribe,
        update(callback) {
            let ret
            update((value) => {
                ret = callback(value)
                return ret
            })
            return ret
        },
        get value() {
            let ret = {}
            subscribe((v) => (ret = v))
            return ret
        }
    }
}

function buildCustomStore() {
    const token = CustomStore(null)
    const currentAccount = CustomStore(null)
    const preHandler = data => {
        let { token: t, ...ret } = data
        token.set(t)
        currentAccount.set(ret?.defaultAccount || null)
        // console.log('PreHandler', {data, token: t})
        return {
            ...Object.fromEntries(
                // ret,
                Object.entries(data).filter(([k]) => {
                    return !['password', 'token'].includes(k)
                })
            ),
            fullName: toTitleCase(`${data.name} ${data.lastName}`),
            shortName: toTitleCase(
                `${data.name.split(' ')[0]} ${data.lastName.split(' ')[0]}`
            ),
            currentIdAccount: data?.accounts[data.defaultAccount]?.id || null,
        }
    }

    let initial = window.localStorage.getItem('UserData')
    initial = initial ? preHandler(JSON.parse(initial)) : null
    if (initial) { window.localStorage.removeItem('UserData') }
    if(!(initial && token.value)) {
        currentAccount.set(null)
        token.set(null)
        initial = null
    }
    const { subscribe, update, set } = writable(initial)
    const getToken = () => derived([token], ([$token]) => $token, null)
    const getCurrentAccount = () => derived([currentAccount], ([$currentAccount]) => $currentAccount, null)

    return {
        subscribe,
        set,
        async logout (msg = undefined, path = undefined) {
            window.localStorage.removeItem('UserData')
            // await Promise.all(['ofertas', 'invoices_sin'].map(async collection_name => {
            //     let collection = db[collection_name]
            //     if (collection){
            //         await collection.toArray(async data => {
            //             await JSONAth.save(collection_name, data)
            //         })
            //     }
            // }))
            token.set(null)
            await tick()
            await set(null)
            navigate('/login', { replace: true, state: { msg, redirect: path } })
        },
        getToken,
        getCurrentAccount,
        _set(data) {
            console.log('calling _set', data)
            let {token, ...ret} = preHandler(data)
            // window.localStorage.setItem(
            //     'UserData',
            //     JSON.stringify(ret)
            // )
            if (ret?.firstLogin) {
                window.localStorage.setItem(
                    'dataConfirmation',
                    'false'
                )
            }
            set(ret)
        },
        async update (data) {
            if (this.token) {
                await this.fetch(`${API_URL}/users`, {
                    method: 'PUT',
                    body: JSON.stringify(data)
                }).then(async (res) => {
                    if (res.ok) {
                        update((val) => {
                            let tmpData = preHandler({ ...val, ...data })
                            let lastUser = JSON.parse(
                                window.localStorage.getItem('lastUser') ||
                                    'null'
                            )
                            console.log(lastUser)
                            // window.localStorage.setItem(
                            //     'UserData',
                            //     JSON.stringify(tmpData)
                            // )
                            if (
                                lastUser &&
                                lastUser['document'] == tmpData['docNumber']
                            ) {
                                window.localStorage.setItem(
                                    'lastUser',
                                    JSON.stringify({
                                        ...lastUser,
                                        name: tmpData.shortName,
                                    })
                                )
                            }
                            return tmpData
                        })
                    } else {
                    }
                })
            }
        },
        async login(user, password, callback = () => {}, service='recaptcha', token=null) {
            console.log('LOGIN')
            let Authorization = `Basic ${window.btoa(user + ':' + password)}`
            let headers = {
                Authorization
            }
            if (service == 'recaptcha') {
                headers['g-recaptcha'] = token
            } else if (service == 'turnstile') {
                headers['cf-turnstile-response'] = token
            }
            return fetch(API_URL + '/auth', {
                headers,
                // credentials: 'include'
            })
            .then(async (r) => {
                let data = await r.json()
                if (r.ok) {
                    let ret = preHandler(data)
                    await set(ret)
                    if (callback) callback(true, ret)
                    // window.localStorage.setItem(
                    //     'UserData',
                    //     JSON.stringify(ret)
                    // )
                    if (ret.firstLogin) {
                        window.localStorage.setItem(
                            'dataConfirmation',
                            'false'
                        )
                    }
                    provider.load()
                    try { this.fetch(`${API_URL}/branchoffices/${this.currentAccount}`).then(async res => {
                        dictionaries.update('branchoffices', await res.json())
                    }) } catch(e) { console.error(e) }
                    return true
                } else {
                    if (callback) callback(false, data)
                    return null
                }
            })
            .catch((e) => {
                console.error(e)
                callback(false, {
                    message:
                        'Se produjo un error al iniciar sesion por favor intente nuevamente más tarde.',
                })
                return null
            })
        },
        validate (path = undefined) {
            let user
            subscribe((data) => {
                user = data
            })
            if (user !== null && user?.until) {
                if (Date.now() / 1000 > (user.until - 5)) {
                    console.log(`${Date.now()} > ${user.until}`)
                    this.logout(
                        'La sesión expiró, por favor ingrese nuevamente.',
                        path
                    )
                }
            }
        },
        get value() {
            let ret = {}
            subscribe((v) => (ret = v))
            return ret
        },
        get token() {
            let ret = null
            token.subscribe(t => {ret = t})
            return ret
        },
        get currentAccount() {
            let ret = null
            currentAccount.subscribe(da => ret = da)
            return ret || undefined
        },
        setAccount(account) {
            currentAccount.set(account)
        },
        async refresh() {
            // return fetch(`${API_URL}/users/me`)
            //     .then(async r => {
            //         if(r.ok) {
            //             let {token, ...attributes} = await r.json()
            //             this._set(attributes)
            //             token.set(token)
            //             return true
            //         } else { return false }
            //     })
            //     .catch(e => {
            //         console.error(e.message)
            //     })
        },
        async fetch(url, options={}) {
            let startedAt = new Date()
            let callId = crypto.randomUUID()
            let { headers={}, ...restOptions } = options
            headers.Authorization = `${this.token}`
            headers['X-Call-Id'] = callId
            return fetch(url, {headers, ...restOptions}).finally(() => {
                let endAt = new Date()
                let data = btoa(
                    JSON.stringify({
                        id: callId,
                        url,
                        duration: (endAt.getTime() - startedAt.getTime()) / 1000,
                        start: startedAt.toISOString(),
                        end: endAt.toISOString()
                    })
                )
                fetch(`${window.location.href}/performance/`.replace(/([^:])(\/{2,})/g, '$1/') + data)
            })
        },
        isLogined() {
            return this.value !== null
        },
        refreshToken: (_) => {}, // Cuando este lista la API
        navigate(path = null, target = '') {
            // Save token
            window.localStorage.setItem('UserData', JSON.stringify({...this.value, token: this.token}))
            if (typeof path === 'string') {
                if(target === '') {
                    window.location.href = path
                } else {
                    window.open(path, target)
                }
            } else {
                window.location.reload()
            }
        }
    }
}
const store = buildCustomStore()
export default store
